PJQ.views.invoicing.EditPayableInvoiceModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.INVOICING, 'modal-payable-invoice-edit'),
        width: '95%',
        maxWidth: 1500,
        model: null,
        isShowCloseButton: true,
        onSave: _.noop(),
        onDelete: _.noop()
    },
    events: {
        'click .btn-view-commitment': 'viewCommitment',
        'click .btn-view-payment': 'viewPaymentClicked',
        'click .btn-new-payment': 'newPayment',
        'change .input-coi-required': 'renderCOIApproval',
        'change .input-w9-required': 'renderW9Approval',
        'change .input-lien-waiver-required': 'renderLienWaiverApproval',
        'click .btn-add-line-item': 'addLineItem',
        'click .btn-delete': 'delete',
        'click .btn-close': 'close',
        'click .btn-submit': 'submitInvoice',
        'click .btn-save-email': 'saveEmail',
        'click .btn-save': 'saveInvoice',
        'click .btn-push-erp': 'pushERP',
        'click .erp-sync-payments .btn-pull-erp': 'pullERPPayments',
        'click .btn-undo-push-erp': 'undoPushERP',
        'click .btn-unlink-erp': 'unlinkERP',
        'click .btn-export': 'exportInvoice',
        'click .btn-email': 'email',
        'click .nav-link': 'activeViewChanged',
        'click .btn-invite-to-bill': 'inviteToBill',
        'change .cb-paid': 'updatePaid',
        'click .btn-itb-respond': 'respondToInviteClicked',
        'click .btn-view-history': 'viewHistory'
    },
    beforeModalCreated: async function () {
        this.isFetched = false;

        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;
        this.coreFieldSettings = await this.options.project.fetchPayableInvoiceFieldSettings();
        this.settings = await this.options.project.fetchPayableInvoiceSettings();
        this.customFields = await this.options.project.fetchPayableInvoiceCustomFields();
        this.billingPeriodSettings = await this.options.project.fetchBillingPeriodSettings();
        this.costCodes = await this.options.project.fetchCostCodes();
        this.costTypes = await this.options.project.fetchCostTypes();
        this.unitsOfMeasure = await this.options.project.fetchUnitsOfMeasure();

        if (this.model == null) {
            let customFieldValues = [];
            _.each(this.customFields.models, function (model, index) {
                let value = model.get('defaultValue') ? model.get('defaultValue') : '';
                if (model.get('fieldType') === 'CHOICE') {
                    value = parseInt(value);
                }
                customFieldValues.push({
                    fieldNumber: model.get('fieldNumber'),
                    fieldTypeId: model.get('fieldTypeId'),
                    fieldType: model.get('fieldType'),
                    isMultiple: model.get('isMultiple'),
                    value: value,
                    id: model.get('id')
                })
            }, this);

            this.model = new PJQ.models.invoicing.PayableInvoice({
                notes: '',
                number: '',
                commitmentId: this.options.commitment.id,
                commitmentType: this.options.commitment.get('commitmentType'),
                commitmentNumber: this.options.commitment.get('number'),
                projectId: this.options.commitment.get('projectId'),
                companyId: this.options.commitment.get('companyId'),
                contractedContact: this.options.commitment.contractedContact,
                contractedContactId: this.options.commitment.get('contractedContactId'),
                invoiceContact: this.options.commitment.invoiceContact,
                invoiceContactId: this.options.commitment.get('invoiceContactId'),
                statusId: PJQ.constants.invoicing.payableInvoiceStatus.DRAFT,
                isCOIRequired: this.options.commitment.get('isCOIRequired'),
                isCOIApproved: this.options.commitment.get('isCOIApproved'),
                coiAttachments: this.options.commitment.coiAttachments.toJSON(),
                isW9Required: this.options.commitment.get('isW9Required'),
                isW9Approved: this.options.commitment.get('isW9Approved'),
                defaultWorkRetainagePercent: this.options.commitment.get('defaultWorkRetainagePercent'),
                defaultMaterialRetainagePercent: this.options.commitment.get('defaultMaterialRetainagePercent'),
                w9Attachments: this.options.commitment.w9Attachments.toJSON(),
                customFieldValues: customFieldValues
            });

            let billingPeriod = _.find(this.billingPeriodSettings.billingPeriods.models, function (billingPeriod) {
                return billingPeriod.get('isCurrent');
            })
            if (billingPeriod != null) {
                this.model.set({
                    billingPeriodId: billingPeriod.id,
                    startDate: PJQ.helpers.dateHelpers.parseDateString(billingPeriod.get('startDate'), false),
                    endDate: PJQ.helpers.dateHelpers.parseDateString(billingPeriod.get('endDate'), false),
                    billingDate: PJQ.helpers.dateHelpers.parseDateString(billingPeriod.get('dueDate'), false)
                });
            }
        }

        if (!this.model.isNew()) {
            await this.model.fetch();
        }

        this.erpIntegration = await PJQ.app.session.fetchERPIntegration();
        if (this.erpIntegration != null && this.erpIntegration.getSetting('syncProjects')) {
            await this.options.project.fetchERPObject();

            if (this.options.commitment == null) {
                this.options.commitment = new PJQ.models.commitments.Commitment({
                    id: this.model.get('commitmentId')
                });
                await this.options.commitment.fetch();
            }
        }

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.options.canEdit = this.options.project.hasPermission('payableInvoices.canEdit');
        this.options.canEditLineItems = this.options.canEdit;
        this.options.canEditBillingDates = this.options.project.hasPermission('payableInvoices.canEdit');
        this.options.isAdmin = this.options.project.hasPermission('payableInvoices.isAdmin');
        this.options.canViewCommitments = this.options.project.hasPermission('commitments.canView');
        this.options.canAddPayments = this.options.canEdit;
        this.options.canDelete = this.options.isAdmin;
        this.options.canEditStatus = this.options.isAdmin;
        this.options.canInviteToBill = this.options.isAdmin && new Date(this.model.get('billingDate')) > new Date() && this.model.get('statusId') === PJQ.constants.invoicing.payableInvoiceStatus.DRAFT;
        this.options.canRespondToInvite = this.model.get('invitedOnDate') != null && this.model.get('inviteStatus') == null && (PJQ.app.session.user?.get('userId') === this.model.contractedContact.get('userId') || PJQ.app.session.user?.get('userId') === this.model.invoiceContact?.get('userId'));

        let status = this.model.get('statusId');
        if (this.model.isNew() || status === PJQ.constants.invoicing.payableInvoiceStatus.DRAFT) {
            this.options.canEdit = true;
            this.options.canEditBillingDates = true;
            this.options.canEditLineItems = true;
            this.options.canDelete = !this.model.isNew();
        } else if (status === PJQ.constants.invoicing.payableInvoiceStatus.APPROVED || status === PJQ.constants.invoicing.payableInvoiceStatus.COMPLETE) {
            this.options.canEdit = PJQ.app.session.project.hasPermission('payableInvoices.canEdit');
            this.options.canEditBillingDates = false;
            this.options.canEditLineItems = false;
            this.options.canDelete = false;
        } else {
            this.options.canEdit = PJQ.app.session.project.hasPermission('payableInvoices.canEdit');
            this.options.canEditBillingDates = PJQ.app.session.project.hasPermission('payableInvoices.canEdit');
            this.options.canEditLineItems = true;
            this.options.canDelete = this.options.isAdmin;
        }

        if (PJQ.app.session.user != null &&
            ((this.model.get('contractedContact') && PJQ.app.session.user.id === this.model.get('contractedContact').userId)
                || (this.model.get('invoiceContact') && PJQ.app.session.user.id === this.model.get('invoiceContact').userId))) {
            this.options.isSubmitting = (status === PJQ.constants.invoicing.payableInvoiceStatus.DRAFT || status === PJQ.constants.invoicing.payableInvoiceStatus.REVISE);

            let today = new Date();
            if (today > new Date(this.model.get('billingDate'))) {
                this.options.canEditBillingDates = false;
                this.options.canEdit = false;
                this.options.canEditLineItems = false;
                this.options.canDelete = false;
                this.options.isSubmitting = false;
            }
        }

        if (status !== PJQ.constants.invoicing.payableInvoiceStatus.APPROVED && status !== PJQ.constants.invoicing.payableInvoiceStatus.COMPLETE) {
            this.options.canAddPayments = false;
        }

        if ((status === PJQ.constants.invoicing.payableInvoiceStatus.APPROVED || status === PJQ.constants.invoicing.payableInvoiceStatus.COMPLETE)
            && (this.model.payments.models.length > 0 || this.model.get('isLatest') === false)) {
            this.options.canEditStatus = false;
            this.options.canEditLineItems = false;
        }

        if (this.model.isNew()) {
            this.options.canEditStatus = false;
        }

        if (this.erpIntegration != null) {
            let syncStatus = this.model.erpSyncStatus();
            if (syncStatus === PJQ.constants.integrations.erp.syncStatuses.REVIEWING
                || syncStatus === PJQ.constants.integrations.erp.syncStatuses.APPROVED
                || syncStatus === PJQ.constants.integrations.erp.syncStatuses.SYNCED
            ) {
                this.options.canEditBillingDates = false;
                this.options.canEdit = false;
                this.options.canEditLineItems = false;
                this.options.canDelete = false;
                this.options.isSubmitting = false;
            }
        }
    },
    renderData: function () {
        return {
            model: this.model,
            erpIntegration: this.erpIntegration,
            customFields: this.customFields,
            billingPeriods: this.billingPeriodSettings != null ? this.billingPeriodSettings.billingPeriods : null,
            canEdit: this.options.canEdit,
            canDelete: this.options.canDelete,
            isAdmin: this.options.isAdmin,
            canViewCommitments: this.options.canViewCommitments,
            canAddPayments: this.options.canAddPayments,
            isSubmitting: this.options.isSubmitting,
            isFetched: this.isFetched,
            canEditBillingDates: this.options.canEditBillingDates,
            settings: this.settings,
            invoiceSettings: this.invoiceSettings,
            activeView: this.options.activeView,
            views: this.views,
            canInviteToBill: this.options.canInviteToBill,
            checkFieldVisible: _.bind(this.checkFieldVisible, this),
            checkFieldRequired: _.bind(this.checkFieldRequired, this),
            canRespondToInvite: this.options.canRespondToInvite
        }
    },
    afterRender: function () {
        if (!this.isFetched) {
            return;
        }

        this.activateView(this.options.activeView);

        this.stopListening(this.model);
        this.listenTo(this.model, 'change:statusId', () => {
            this.renderERP();
        });
        this.stopListening(this.model.lineItems);
        this.listenTo(this.model.lineItems, 'update', () => {
            this.renderERP();
        });
        this.renderERP();

        this.renderGeneral();
        if (!this.model.isNew()) {
            this.renderLineItems();
            this.renderPayments();
        }
        this.updateCounts();

        if (this.options.inviteResponse != null && this.model.get('invitedOnDate') != null && this.model.get('inviteStatus') == null) {
            this.handleInviteResponse();
        }
    },
    respondToInviteClicked: function (e) {
        let target = $(e.currentTarget),
            value = target.data('value');

        this.handleInviteResponse(value);
    },
    handleInviteResponse: function (responseValue) {
        let response = responseValue != null ? responseValue : this.options.inviteResponse,
            fnUpdateResponse = () => {
                this.model.updateInviteStatus(response, (updatedModel) => {
                    PJQ.notifications.notify.successNotify({
                        message: 'Invoice response updated successfully'
                    });
                    this.model.reset(updatedModel);

                    if (typeof this.options.onSave === 'function')
                        this.options.onSave(this.model, false);

                    this.render();
                });
            };

        if (response === 0) {
            new PJQ.views.modals.YesNo({
                header: "Decline Invitation",
                body: "Are you sure you want to decline to bill this period?",
                onYes: _.bind(function () {
                    fnUpdateResponse();
                }, this)
            });
        } else {
            fnUpdateResponse();
        }
    },
    updateCounts: function () {
        this.$('.count-line-items').text(_.size(this.model.lineItems.models));
        this.$('.count-payments').text(_.size(this.model.payments.models));
    },
    views: {
        GENERAL: 'PI_General',
        LINEITEMS: 'PI_LineItems',
        PAYMENTS: 'PI_Payments',
        SUMMARY: 'PI_Summary'
    },
    activeViewChanged: function (e) {
        let view = e.target.hash ? e.target.hash.replace('#', '') : null;
        this.activateView(view);
    },
    activateView: function (view) {
        switch (view) {
            case this.views.LINEITEMS:
            case this.views.PAYMENTS:
                // do nothing
                break;
            case this.views.SUMMARY:
                this.renderSummary();
                break;
            default:
                view = this.views.GENERAL;
                break;
        }

        this.$('.nav-link[href="#' + view + '"]').tab('show');
        this.options.activeView = view;
    },
    validateApproval: function () {
        let isValid = true;
        if (this.model.get('statusId') === PJQ.constants.invoicing.payableInvoiceStatus.APPROVED || this.model.get('statusId') === PJQ.constants.invoicing.payableInvoiceStatus.COMPLETE) {
            if (this.model.get('isCOIRequired')) {
                let $coi = this.$('.coi-alert');
                $coi.empty();
                if (!this.model.get('isCOIApproved')) {
                    new PJQ.Alert($coi, {
                        type: 'danger',
                        text: 'You must approve this item before approving the invoice'
                    });
                    isValid = false;
                }
            }

            if (this.model.get('isW9Required')) {
                let $w9 = this.$('.w9-alert');
                $w9.empty();
                if (!this.model.get('isW9Approved')) {
                    new PJQ.Alert($w9, {
                        type: 'danger',
                        text: 'You must approve this item before approving the invoice'
                    });
                    isValid = false;
                }
            }
        }
        return isValid;
    },
    renderGeneral: function () {
        new PJQ.Binder(this.$el, this.model, {
            canEdit: !this.options.canEdit ? false : null,
            useDecimalPercentFields: true,
            watchElements: [
                'input',
                'textarea'
            ]
        });

        new PJQ.views.contacts.ContactsSelectInput({
            el: this.$('.invoice-contracted-company'),
            selectedContact: this.model.contractedContact,
            canViewContacts: this.options.project.hasPermission('projectContacts.canView'),
            canEdit: false,
            displayContactsBlock: true,
        });

        new PJQ.views.contacts.ContactsSelectInput({
            el: this.$('.invoice-contact'),
            selectedContact: this.model.invoiceContact,
            canViewContacts: this.options.project.hasPermission('projectContacts.canView'),
            canEdit: false,
            displayContactsBlock: true,
        });

        this.statusPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-status'),
            isIntChoices: true,
            defaultValue: this.model.get('statusId'),
            canEdit: this.options.canEditStatus,
            choices: _.map(PJQ.constants.invoicing.payableInvoiceStatus, (st) => {
                return {
                    id: st,
                    name: PJQ.constants.invoicing.payableInvoiceStatusNames[st],
                    disabled: this.options.disabledStatuses != null && this.options.disabledStatuses.indexOf(st) > -1
                }
            }),
            onChange: _.bind(function (newStatus) {
                let oldStatus = this.model.get('statusId');
                if (newStatus === oldStatus) {
                    return;
                }

                this.model.set('statusId', newStatus);
                if (!this.model.isNew()) {
                    this.save((success) => {
                        if (success) {
                            PJQ.notifications.notify.successNotify({
                                message: 'Invoice saved successfully'
                            });
                        } else {
                            this.model.set('statusId', oldStatus);
                            this.statusPicker.setValue(oldStatus);
                        }
                    });
                } else {
                    this.render();
                }
            }, this)
        });

        new PJQ.inputs.Selectpicker({
            el: this.$('.select-billing-period'),
            defaultValue: this.model.get('billingPeriodId'),
            isMultiple: false,
            isIntChoices: true,
            canEdit: this.options.canEdit,
            onChange: _.bind(function (value) {
                let billingPeriod = this.billingPeriodSettings != null && value != null ? this.billingPeriodSettings.billingPeriods.get(value) : null;
                this.model.set('billingPeriodId', value);
                this.$('.period-start').attr('disabled', billingPeriod != null);
                this.$('.period-end').attr('disabled', billingPeriod != null);
                if (billingPeriod != null) {
                    let startDate = PJQ.helpers.dateHelpers.parseDateString(billingPeriod.get('startDate'), false),
                        endDate = PJQ.helpers.dateHelpers.parseDateString(billingPeriod.get('endDate'), false),
                        dueDate = PJQ.helpers.dateHelpers.parseDateString(billingPeriod.get('dueDate'), false);
                    this.periodStartPicker.setValue(startDate);
                    this.model.set('startDate', startDate);

                    this.periodEndPicker.setValue(endDate);
                    this.model.set('endDate', endDate);

                    this.dueDatePicker.setValue(dueDate);
                    this.model.set('billingDate', dueDate);
                }
            }, this)
        });

        this.periodStartPicker = new PJQ.inputs.Datepicker({
            el: this.$('.period-start'),
            canEdit: this.options.canEdit && !(this.model.get('billingPeriodId') > 0),
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('startDate') != null ? PJQ.helpers.dateHelpers.parseDateString(this.model.get('startDate'), false) : null
            },
            onChange: _.bind(function (newDate) {
                this.model.set('startDate', newDate);
            }, this)
        });

        this.periodEndPicker = new PJQ.inputs.Datepicker({
            el: this.$('.period-end'),
            canEdit: this.options.canEdit && !(this.model.get('billingPeriodId') > 0),
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('endDate') != null ? PJQ.helpers.dateHelpers.parseDateString(this.model.get('endDate'), false) : null
            },
            onChange: _.bind(function (newDate) {
                this.model.set('endDate', newDate);
            }, this)
        });

        this.dueDatePicker = new PJQ.inputs.Datepicker({
            el: this.$('.due-date'),
            canEdit: this.options.canEdit,
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('billingDate') != null ? PJQ.helpers.dateHelpers.parseDateString(this.model.get('billingDate'), false) : null
            },
            onChange: _.bind(function (newDate) {
                this.model.set('billingDate', newDate);
            }, this)
        });

        if (this.checkFieldVisible('attachments')) {
            this.fileUploader = new PJQ.views.files.FileUploaderGrid({
                el: this.$('.invoice-file-uploader'),
                collection: this.model.attachments,
                canUpload: this.options.canEdit,
                useApiV2: true,
                canView: false,
                canDelete: this.options.canEdit && this.options.isAdmin,
                previewImageDimension: 150,
                onSuccess: _.bind(function (file) {
                    this.model.isDirty = true;
                }, this),
                onDelete: _.bind(function (attachment, callback) {
                    if (attachment.id > 0) {
                        attachment.set('delete', true);
                    } else {
                        attachment.destroy();
                    }

                    this.model.isDirty = true;
                    callback();
                }, this)
            });
        }

        if (this.checkFieldVisible('coiAttachments')) {
            this.coiUploader = new PJQ.views.files.FileUploaderGrid({
                el: this.$('.coi-file-uploader'),
                collection: this.model.coiAttachments,
                canUpload: this.options.canEdit,
                useApiV2: true,
                canView: false,
                canDelete: this.options.isAdmin,
                previewImageDimension: 150,
                onSuccess: _.bind(function (file) {
                    this.model.isDirty = true;
                }, this),
                onDelete: _.bind(function (attachment, callback) {
                    if (attachment.get('id') > 0) {
                        attachment.set('delete', true);
                    } else {
                        attachment.destroy();
                    }

                    this.model.isDirty = true;
                    callback();
                }, this)
            });
            this.renderCOIApproval();
        }

        if (this.checkFieldVisible('w9Attachments')) {
            this.w9Uploader = new PJQ.views.files.FileUploaderGrid({
                el: this.$('.w9-file-uploader'),
                collection: this.model.w9Attachments,
                canUpload: this.options.canEdit,
                useApiV2: true,
                canView: false,
                canDelete: this.options.isAdmin,
                previewImageDimension: 150,
                onSuccess: _.bind(function (file) {
                    this.model.isDirty = true;
                }, this),
                onDelete: _.bind(function (attachment, callback) {
                    if (attachment.get('id') > 0) {
                        attachment.set('delete', true);
                    } else {
                        attachment.destroy();
                    }

                    this.model.isDirty = true;
                    callback();
                }, this)
            });
            this.renderW9Approval();
        }

        if (this.checkFieldVisible('lienWaiverAttachments')) {
            this.lienWaiverUploader = new PJQ.views.files.FileUploaderGrid({
                el: this.$('.lien-waiver-file-uploader'),
                collection: this.model.lienWaiverAttachments,
                canUpload: this.options.canEdit,
                useApiV2: true,
                canView: false,
                canDelete: this.options.isAdmin,
                previewImageDimension: 150,
                onSuccess: _.bind(function (file) {
                    this.model.isDirty = true;
                }, this),
                onDelete: _.bind(function (attachment, callback) {
                    if (attachment.get('id') > 0) {
                        attachment.set('delete', true);
                    } else {
                        attachment.destroy();
                    }

                    this.model.isDirty = true;
                    callback();
                }, this)
            });
            this.renderLienWaiverApproval();
        }

        if (this.customFields && _.size(this.customFields.models) > 0) {
            this.customFieldsForm = new PJQ.views.customFields.CustomFieldsForm({
                el: this.$('.payable-invoice-custom-fields'),
                collection: this.customFields,
                fieldValues: this.model.get('customFieldValues'),
                isEdit: this.options.canEdit,
                isAdmin: this.options.isAdmin,
            });
        }
    },
    renderCOIApproval: function () {
        if (this.coiApproval != null) {
            this.coiApproval.remove();
        }
        if (this.model.get('isCOIRequired')) {
            this.coiApproval = new PJQ.inputs.ButtonGroup({
                el: this.$('.coi-approval'),
                canEdit: this.options.canEdit && this.options.isAdmin,
                colorInactiveButtons: false,
                buttonClasses: 'wd-120p',
                buttons: [
                    {
                        label: "Not Reviewed",
                        value: null,
                        colorClass: "light"
                    },
                    {
                        label: "Rejected",
                        value: false,
                        colorClass: "danger"
                    },
                    {
                        label: "Approved",
                        value: true,
                        colorClass: "success"
                    }
                ],
                defaultValue: this.model.get('isCOIApproved'),
                onChange: _.bind(function (value) {
                    this.model.set('isCOIApproved', value);
                }, this)
            });
        }
    },
    renderW9Approval: function () {
        if (this.w9Approval != null) {
            this.w9Approval.remove();
        }
        if (this.model.get('isW9Required')) {
            this.w9Approval = new PJQ.inputs.ButtonGroup({
                el: this.$('.w9-approval'),
                canEdit: this.options.canEdit && this.options.isAdmin,
                colorInactiveButtons: false,
                buttonClasses: 'wd-120p',
                buttons: [
                    {
                        label: "Not Reviewed",
                        value: null,
                        colorClass: "light"
                    },
                    {
                        label: "Rejected",
                        value: false,
                        colorClass: "danger"
                    },
                    {
                        label: "Approved",
                        value: true,
                        colorClass: "success"
                    }
                ],
                defaultValue: this.model.get('isW9Approved'),
                onChange: _.bind(function (value) {
                    this.model.set('isW9Approved', value);
                }, this)
            });
        }
    },
    renderLienWaiverApproval: function () {
        if (this.lienWaiverApproval != null) {
            this.lienWaiverApproval.remove();
        }
        if (this.model.get('isLienWaiverRequired')) {
            this.lienWaiverApproval = new PJQ.inputs.ButtonGroup({
                el: this.$('.lien-waiver-approval'),
                canEdit: this.options.canEdit && this.options.isAdmin,
                colorInactiveButtons: false,
                buttonClasses: 'wd-120p',
                buttons: [
                    {
                        label: "Not Reviewed",
                        value: null,
                        colorClass: "light"
                    },
                    {
                        label: "Rejected",
                        value: false,
                        colorClass: "danger"
                    },
                    {
                        label: "Approved",
                        value: true,
                        colorClass: "success"
                    }
                ],
                defaultValue: this.model.get('isLienWaiverApproved'),
                onChange: _.bind(function (value) {
                    this.model.set('isLienWaiverApproved', value);
                }, this)
            });
        }
    },
    renderSummary: function () {
        this.summaryView = new PJQ.views.invoicing.InvoiceSummary({
            el: this.$('.invoice-summary'),
            model: this.model,
            export: () => {
                this.save(() => {
                    PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
                        {
                            endpoint: 'payableinvoices',
                            value: this.model.get('id')
                        },
                        {
                            endpoint: 'summary'
                        },
                        {
                            endpoint: 'export',
                        }
                    ]), {isAPIv2: true});
                });
            }
        })
    },
    renderLineItems() {
        if(this.lineItemsView){
            this.lineItemsView.remove();
        }

        this.lineItemsView = new PJQ.views.budget.LineItemsView({
            el: this.$('.invoice-line-items'),
            model: this.model,
            collection: this.model.lineItems,
            lineItemModel: PJQ.models.invoicing.PayableInvoiceLineItem,
            isSubmitting: this.options.isSubmitting,
            canEdit: this.options.isSubmitting || (this.options.canEdit && this.options.canEditLineItems),
            canDelete: this.options.isSubmitting || (this.options.canEdit && this.options.canEditLineItems),
            isAdmin: this.options.isAdmin,
            enableStoredMaterials: this.settings.get('enableStoredMaterials'),
            enableRetainage: this.settings.get('enableRetainage'),
            enableSelection: this.options.isSubmitting || (this.options.canEdit && this.options.canEditLineItems),
            enableTax: true,
            canImportBudget: false,
            showSubTotal: true,
            showGrandTotal: true,
            onLineItemChange: _.bind(function () {
                this.model.isDirty = true;
            }, this),
            onLineItemAdd: _.bind(function () {
                this.model.isDirty = true;
                this.updateCounts();
            }, this),
            onLineItemDelete: _.bind(function () {
                this.model.isDirty = true;
                this.updateCounts();
            }, this),
            onCommitmentView: _.bind(function () {
                this.removeModal();
            }, this),
            onChangeOrderView: _.bind(function () {
                this.removeModal();
            }, this),
        });
    },
    pullERPPayments: function () {
        if (this.model.isERPSynced() && this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PULL_PAYABLE_PAYMENTS)) {
            this.erpIntegration.pullPayableInvoicePayments(this.model, (res) => {
                PJQ.notifications.notify.successNotify({
                    message: 'Payments successfully pulled from ERP'
                });

                this.model.payments.reset(res);
                this.renderPayments();
            });
        }
    },
    renderPayments: function () {
        if (this.model.isNew()) {
            return;
        }

        this.paymentsDataTable = new PJQ.views.dataTables.DataTable({
            el: this.$('.invoice-payments'),
            data: this.model.payments.models,
            isHideSearch: true,
            language: {
                emptyTable: 'No Payments have been created yet',
                zeroRecords: "No Payments matched the search criteria"
            },
            paging: false,
            order: [],
            columns: [{
                "columnData": "",
                "data": null,
                "title": "",
                "width": "20px",
                "orderable": false,
                "searchable": false,
                "defaultContent": '',
                "render": function (data, type, row) {
                    if (row.isERPSynced()) {
                        return PJQ.helpers.erp.getERPIcon(row.erpSyncStatus());
                    }
                    return '';
                }
            }, {
                "title": "#",
                "data": "attributes.number",
                "render": _.bind(function (data, type, row) {
                    return '<a href="javascript:void(0)" class="btn-view-payment">' + data + '</a>'
                }, this)
            },
                {
                    "title": 'Received',
                    "data": "",
                    "render": _.bind(function (data, type, row) {
                        let dateReceived = row.get('dateReceived');
                        if (_.size(dateReceived) === 0) {
                            return '';
                        }

                        return PJQ.helpers.dateHelpers.getDateString(new Date(dateReceived), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                    }, this)
                },
                {
                    "data": "attributes.amount",
                    "title": "Amount",
                    "render": _.bind(function (data, type, row) {
                        return PJQ.helpers.formatHelpers.formatCurrency(row.get('amount'));
                    }, this)
                },
                {
                    "data": "",
                    "title": "",
                    "orderable": false,
                    "searchable": false,
                    "width": "80px",
                    "render": _.bind(function (data, type, row) {
                        let html = '<div class="text-align-right show-on-row-hover">'
                        if (this.options.canViewInvoices) {
                            html += '<button type="button" class="btn btn-info btn-view-payment ht-30p wd-35p ml-1 fs-14"><span class="fal fa-pencil"></span></button>'
                        }
                        return html + '</div>';
                    }, this)
                }],
            dom: '<"top"<"clear">>rt<"bottom"p<"clear">>',
            contextMenuOptions: {
                actions: [
                    {
                        name: 'View',
                        onClick: _.bind(function (row) {
                            this.viewPayment(row.data());
                        }, this),
                        isShown: _.bind(function (row) {
                            return this.options.canViewInvoices;
                        }, this)
                    }
                ]
            },
            onRowDoubleClick: _.bind(function (row) {
                this.viewPayment(row.data());
            }, this)
        });
    },
    newPayment: function () {
        this.viewPayment();
    },
    viewPaymentClicked: function (e) {
        let target = $(e.currentTarget),
            row = this.paymentsDataTable.getRow(target.closest('tr'));
        this.viewPayment(row.data());
    },
    viewPayment: function (payment) {
        this.removeModal();
        new PJQ.views.invoicing.InvoicePaymentModal({
            model: payment,
            invoice: this.model,
            isPayable: true,
            onSave: _.bind(function (payment, isNew) {
                if (isNew) {
                    this.model.payments.add(payment);
                    this.paymentsDataTable.addRow(payment);
                }
                this.updateCounts();

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }
            }, this),
            onDelete: _.bind(function () {
                this.updateCounts();

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }
            }, this)
        });
    },
    viewCommitment: function () {
        this.removeModal();
        new PJQ.views.commitments.CommitmentEditModal({
            model: new PJQ.models.commitments.Commitment({
                id: this.model.get('commitmentId')
            }),
            onSave: () => {
                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }
            },
            onDelete: () => {
                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }
            }
        });
    },
    renderERP: function () {
        let $erp = this.$('.erp-sync');
        if (!this.options.isAdmin || this.erpIntegration == null || !this.options.project.isERPSynced() || this.model.isNew()) {
            $erp.remove();
            return;
        }

        this.$('.erp-badge').html(PJQ.helpers.erp.getERPBadge(this.model.erpSyncStatus(), this.model.get('externalObject')));

        let canPush = true,
            disablePushReason = "";

        if (_.size(this.model.lineItems) === 0
            || (this.model.get('statusId') !== PJQ.constants.invoicing.payableInvoiceStatus.APPROVED && this.model.get('statusId') !== PJQ.constants.invoicing.payableInvoiceStatus.COMPLETE)) {
            canPush = false;
            disablePushReason = "Invoice must be approved or complete and have line items";
        }

        if (!this.options.commitment.isERPSynced() && !this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_PAYABLE_INVOICES_WO_SYNCED_COMMMITMENT)) {
            canPush = false;
            disablePushReason = "The commitment for this invoice is not synced";
        }

        PJQ.helpers.erp.renderERPButtons($erp, {
            pushSupported: this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_PAYABLE_INVOICES),
            canPush: canPush,
            disablePushReason: disablePushReason,
            status: this.model.erpSyncStatus(),
            unlinkSupported: this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.UNLINK_PAYABLE_INVOICES),
            canPushChanges: false
        });

        let $erpPayments = this.$('.erp-sync-payments');
        PJQ.helpers.erp.renderERPButtons($erpPayments, {
            pushSupported: false,
            pullSupported: this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PULL_PAYABLE_PAYMENTS)
        });
    },
    pushERP: function (callback) {
        if (!this.erpIntegration.hasAvailableAction(PJQ.constants.integrations.actions.PUSH_PAYABLE_INVOICES)) {
            return;
        }

        this.save((success) => {
            if (success) {
                this.erpIntegration.pushPayableInvoice(this.model, _.bind(function () {
                    PJQ.notifications.notify.successNotify({
                        message: 'Invoice pushed to ERP'
                    });

                    if (typeof this.options.onSave === 'function') {
                        this.options.onSave(this.model);
                    }

                    if (typeof callback === 'function') {
                        callback();
                    } else {
                        this.render();
                    }
                }, this));
            }
        });
    },
    undoPushERP: function () {
        if (this.model.erpSyncStatus() === PJQ.constants.integrations.erp.syncStatuses.REVIEWING) {
            this.erpIntegration.undoPush(this.model, _.bind(function () {
                PJQ.notifications.notify.successNotify({
                    message: 'Payable Invoice removed from ERP approval'
                });

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }

                this.render();
            }, this));
        }
    },
    unlinkERP: function () {
        new PJQ.views.modals.YesNo({
            header: "Unlink from ERP",
            body: "Are you sure you want to unlink this Payable Invoice from your ERP system?",
            onYes: () => {
                let loader = new PJQ.Loader(this.$('.modal-content'));
                this.erpIntegration.unlinkPayableInvoice(this.model, (success) => {
                    if (success) {
                        loader.remove();
                        PJQ.notifications.notify.successNotify({
                            message: 'Payable Invoice unlinked from ERP'
                        });

                        if (typeof this.options.onSave === 'function') {
                            this.options.onSave(this.model);
                        }

                        this.render();
                    }
                });
            }
        });
    },
    checkFieldVisible: function (fieldName) {
        if (this.coreFieldSettings) {
            let fieldSettings = this.coreFieldSettings.findWhere({fieldName: fieldName});
            if (fieldSettings != null) {
                return fieldSettings.get('isVisible');
            }
        }
        return true;
    },
    checkFieldRequired: function (fieldName) {
        if (this.coreFieldSettings) {
            let fieldSettings = this.coreFieldSettings.findWhere({fieldName: fieldName});
            if (fieldSettings != null) {
                return fieldSettings.get('isRequired');
            }
        }
        return false;
    },
    viewHistory: async function () {
        let historyItems = [{
            date: this.model.get('createdOn'),
            person: this.model.get('createdBy'),
            action: 'Invoice Created'
        }];

        let history = new PJQ.collections.invoicing.PayableInvoiceHistory({}, {
            invoiceId: this.model.id
        });
        new PJQ.views.history.HistoryTimelineModal({
            collection: history,
            subTitle: 'Payable Invoice #' + this.model.get('number'),
            items: historyItems
        });
    },
    exportInvoice: function () {
        let callback = _.bind(function () {
            PJQ.files.downloadFile(PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'payableinvoices',
                    value: this.model.get('id')
                },
                {
                    endpoint: 'export',
                }
            ]), {isAPIv2: true});
        }, this);

        if (this.options.canEdit && this.model.hasChanged()) {
            this.save(callback);
        } else {
            callback();
        }
    },
    delete: function () {
        new PJQ.views.modals.DeleteCancel({
            header: "Delete Invoice",
            body: "Are you sure you want to delete this Invoice?",
            onDelete: _.bind(function () {
                if (typeof this.options.onDelete === 'function') {
                    this.options.onDelete(this.model);
                }
                this.model.destroy({
                    success: _.bind(function () {
                        PJQ.notifications.notify.successNotify({
                            message: 'Invoice successfully deleted'
                        });
                        this.removeModal();
                    }, this)
                });
            }, this)
        });
    },
    validate: function () {
        let isValid = true;
        this.periodStartPicker.hideError();
        this.periodEndPicker.hideError();
        this.dueDatePicker.hideError();

        if (this.model.get('startDate') == null) {
            isValid = false;
            this.periodStartPicker.showError();
        }
        if (this.model.get('endDate') == null) {
            isValid = false;
            this.periodEndPicker.showError();
        }
        if (this.model.get('billingDate') == null) {
            isValid = false;
            this.dueDatePicker.showError();
        }
        if (this.customFieldsForm != null && !this.customFieldsForm.validate()) {
            isValid = false;
        }

        if (!this.validateApproval()) {
            isValid = false;
        }

        if (this.checkFieldRequired('number')) {
            let $number = this.$('.invoice-number');
            PJQ.helpers.inputHelpers.setInputError($number, true);
            if (_.size(this.model.get('number')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($number, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('notes')) {
            let $notes = this.$('.invoice-notes');
            PJQ.helpers.inputHelpers.setInputError($notes, true);
            if (_.size(this.model.get('notes')) === 0) {
                PJQ.helpers.inputHelpers.setInputError($notes, false);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('attachments')) {
            this.fileUploader.clearError();
            let hasValidAttachment = _.find(this.model.attachments.models, function (model) {
                return !model.get('delete')
            }, this) != null;

            if (!hasValidAttachment) {
                this.fileUploader.showError('Missing attachment', 100000);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('coiAttachments')) {
            this.coiUploader.clearError();
            let hasValidAttachment = _.find(this.model.coiAttachments.models, function (model) {
                return !model.get('delete')
            }, this) != null;

            if (!hasValidAttachment) {
                this.coiUploader.showError('Missing attachment', 100000);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('w9Attachments')) {
            this.w9Uploader.clearError();
            let hasValidAttachment = _.find(this.model.w9Attachments.models, function (model) {
                return !model.get('delete')
            }, this) != null;

            if (!hasValidAttachment) {
                this.w9Uploader.showError('Missing attachment', 100000);
                isValid = false;
            }
        }

        if (this.checkFieldRequired('lienWaiverAttachments')) {
            this.lienWaiverUploader.clearError();
            let hasValidAttachment = _.find(this.model.lienWaiverAttachments.models, function (model) {
                return !model.get('delete')
            }, this) != null;

            if (!hasValidAttachment) {
                this.lienWaiverUploader.showError('Missing attachment', 100000);
                isValid = false;
            }
        }

        if (!isValid && this.options.activeView !== 'general') {
            this.options.activeView = 'general';
            this.$('.nav-tabs a[href="#I_General"]').tab('show');
        }

        return isValid;
    },
    submitInvoice: function () {
        this.model.submit(null, _.bind(function (result) {
            if (result) {
                PJQ.notifications.notify.successNotify({
                    message: 'Invoice submitted successfully'
                });

                if (typeof this.options.onSave === 'function')
                    this.options.onSave(this.model);

                this.removeModal();
            }
        }, this));
    },
    saveEmail: function () {
        let isNew = this.model.isNew();
        this.save((success) => {
            if (success) {
                let notifyText = isNew ? 'Invoice created successfully' : 'Invoice saved successfully';
                PJQ.notifications.notify.successNotify({
                    message: notifyText
                });

                this.email();
            }
        });
    },
    saveInvoice: function () {
        let isNew = this.model.isNew();
        this.save((success) => {
            if (success) {
                let notifyText = isNew ? 'Invoice created successfully' : 'Invoice saved successfully';
                PJQ.notifications.notify.successNotify({
                    message: notifyText
                });

                if (!isNew) {
                    this.removeModal()
                }
            }
        });
    },
    save: function (callback) {
        if (!this.validate()) {
            this.$('.modal').prevObject.scrollTop(0);
            if (typeof callback === 'function') {
                callback(false);
            }
            return;
        }

        this.model.save({
            customFields: this.customFieldsForm != null ? this.customFieldsForm.getChanged() : null,
            lineItems: this.model.lineItems.toJSON()
        }, {
            success: () => {
                this.render();
                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }

                PJQ.app.session.project.trigger('payableInvoiceChanged', this.model);
                if (typeof callback === 'function') {
                    callback(true);
                }
            },
            error: () => {
                if (typeof callback === 'function') {
                    callback(false);
                }
                PJQ.notifications.notify.errorNotify({
                    message: "Encountered an error while saving this Invoice. Please contact customer service."
                });
            }
        });
    },
    email: function () {
        let projectName = this.options.project?.get('projectName')?.trim();
        let subject = `An invoice has been shared with you ${projectName && _.size(projectName) > 0 ? `for ${projectName}` : ''}`;
        new PJQ.views.email.ComposeEmailModal({
            header: "Email Invoice",
            project: PJQ.app.session.project,
            subject: subject,
            onSave: _.bind(function (data) {
                this.model.share(data, _.bind(function () {
                    PJQ.notifications.notify.successNotify({
                        message: 'Invoice email sent'
                    });
                }, this));
            }, this)
        });
    },
    inviteToBill: function () {
        this.save((success) => {
            if (success) {
                new PJQ.ajax.Request({
                    endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                        {
                            endpoint: 'payableinvoices',
                            value: this.model.get('id')
                        },
                        {
                            endpoint: 'invitetobill',
                        }
                    ]),
                    isAPIv2: true
                }).post().done(() => {
                    PJQ.notifications.notify.successNotify({
                        message: 'Invitation to Bill sent'
                    });
                }).fail((xhr, err, result) => {

                });
            }
        });
    },
    updatePaid: function (e) {
        this.model.set('paid', $(e.currentTarget).prop('checked'));
        if (!this.options.canEdit && this.options.isAdmin) {
            this.save(() => {
                PJQ.notifications.notify.successNotify({
                    message: 'Invoice saved successfully'
                });
            });
        }
    },
    close: function () {
        if (this.model.hasChanged() && this.options.canEdit) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.saveInvoice();
                    this.removeModal();
                }, this),
                onDontSave: _.bind(function () {
                    this.removeModal();
                }, this)
            });
        } else {
            this.removeModal();
        }
    }
});